import { j as jsxRuntimeExports } from "../../../jsx-runtime-9d42c573.js";
import { useMemo, Children, Fragment, cloneElement } from "react";
import { useInView } from "react-intersection-observer";
import { ImgLoadStatus } from "../constants/constants.js";
import { twMerge } from "tailwind-merge";
import Placeholder from "./placeholder.js";
const CroppedImageContainer = ({
  wrapperClassName = "",
  wrapperStyle = {},
  className = "",
  lazyLoad,
  lazyLoadConfigs,
  imgLoadStatus,
  showLoadingPlaceholder,
  placeholder = null,
  showErrorPlaceholder,
  errorPlaceholder = null,
  loadingPlaceholderClassName = "",
  errorPlaceholderClassName = "",
  children
}) => {
  const _lazyload = lazyLoad ?? true;
  const _showLoadingPlaceholder = showLoadingPlaceholder ?? true;
  const _showErrorPlaceholder = showErrorPlaceholder ?? true;
  const { ref, inView } = useInView({
    threshold: (lazyLoadConfigs == null ? void 0 : lazyLoadConfigs.threshold) || 0.05,
    triggerOnce: true,
    skip: !_lazyload,
    // Skip the observer if lazyLoad is false
    ...lazyLoadConfigs
  });
  const isAlive = useMemo(() => {
    return _lazyload ? imgLoadStatus === ImgLoadStatus.loaded && inView : imgLoadStatus === ImgLoadStatus.loaded;
  }, [imgLoadStatus, inView, _lazyload]);
  const getPlaceholderProps = (type) => {
    return {
      type,
      showLoadingPlaceholder: _showLoadingPlaceholder,
      placeholder,
      showErrorPlaceholder: _showErrorPlaceholder,
      errorPlaceholder,
      loadingPlaceholderClassName,
      errorPlaceholderClassName
    };
  };
  const _renderPlaceholder = () => {
    if (isAlive)
      return null;
    if (_showLoadingPlaceholder && imgLoadStatus === ImgLoadStatus.loading) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Placeholder, { ...getPlaceholderProps("loading") });
    }
    if (_showErrorPlaceholder && imgLoadStatus === ImgLoadStatus.loadError) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Placeholder, { ...getPlaceholderProps("error") });
    }
    return null;
  };
  const childrenArray = Children.toArray(children);
  const firstChild = childrenArray == null ? void 0 : childrenArray[0];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref,
      className: twMerge("w-full h-full", wrapperClassName),
      style: wrapperStyle,
      "data-component": "CroppedImage",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: _renderPlaceholder() }, "placeholder"),
        (!_lazyload || _lazyload && inView) && cloneElement(firstChild, { className: twMerge(!isAlive ? "hidden" : "", className) })
      ]
    }
  );
};
export {
  CroppedImageContainer as default
};
//# sourceMappingURL=container.js.map
